import { useCallback, useContext } from 'react';
import type React from 'react';
import ConditionalTile from '@/ConditionalTiles/ConditionalTile';
import { useIsMobile } from '~/contexts/DeviceContext';
import ModalContext from '~/contexts/ModalContext';
import CalcPercentage from '~/icons/CalcPercentage';
import ClickableTile from '../ClickableTile';

export default function FinanceTile() {
  const isMobile = useIsMobile();
  const { setSoftPullModalOpen } = useContext(ModalContext);
  const heading1 = `Finance with Carvana${isMobile ? ',' : ''}`;
  const heading2 = isMobile ? 'no impact to your credit' : '';
  const subHeading =
    'Real, personalized financing terms in less than 2 minutes, with no impact to your credit.';
  const button = 'GET PRE-QUALIFIED NOW';

  const handleClick = useCallback<React.MouseEventHandler>(
    ev => {
      ev.preventDefault();
      setSoftPullModalOpen(true);
    },
    [setSoftPullModalOpen]
  );

  return (
    <ClickableTile
      tileId="financetile"
      name="FinanceTile"
      smallerSize={isMobile}
      handleTileClick={handleClick}
    >
      <ConditionalTile
        isMobile={isMobile}
        hasToolTip={false}
        svgIcon={<CalcPercentage />}
        hasButton
        data={{
          content: { heading1, heading2, subHeading },
          button
        }}
        small={isMobile}
        primaryButton
      />
    </ClickableTile>
  );
}
